var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineShuffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "572C772A-035D-4C5D-A935-9579CBC73843") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video,-Audio,-Image",
    transform: "translate(-748.000000, -508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shuffle",
    transform: "translate(748.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54025269,18.7399902 L2.99023438,18.7299805 C2.58023438,18.7299805 2.24023438,18.3899805 2.24023438,17.9799805 C2.24023438,17.5699805 2.58023438,17.2299805 2.99023438,17.2299805 L5.54025269,17.2399902 L5.55023193,17.2399902 C6.20023191,17.2399902 6.81025755,16.9199951 7.17025757,16.3699951 L13.5602417,6.78997803 C14.2002417,5.82997805 15.2702368,5.25 16.4302368,5.25 C16.4369165,5.25 16.4435897,5.25 16.4502563,5.25 L21.0002441,5.27001953 C21.4102441,5.27001953 21.7502441,5.61001953 21.7502441,6.02001953 C21.7502441,6.43001953 21.4102441,6.77001953 21.0002441,6.77001953 L16.4502563,6.75 L16.4402466,6.75 C15.7902466,6.75 15.1802515,7.06999511 14.8202515,7.61999512 L8.43023682,17.2000122 C7.79023683,18.1700122 6.72024167,18.7399902 5.5602417,18.7399902 C5.55358236,18.7399902 5.54691935,18.7399902 5.54025269,18.7399902 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4694531,20.5099194 C18.1794531,20.2199194 18.1794531,19.7399218 18.4694531,19.4499218 L20.4694531,17.4499219 C20.7594531,17.1599219 21.2394507,17.1599219 21.5294507,17.4499219 C21.8194506,17.7399219 21.8194506,18.2199194 21.5294507,18.5099194 L19.5294507,20.5099194 C19.3794506,20.6599194 19.1894519,20.7298901 18.9994519,20.7298901 C18.8094519,20.7298901 18.6194531,20.6599194 18.4694531,20.5099194 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27999878,9.06976318 L7.20001221,7.56976318 C6.8300122,7.05976319 6.21998537,6.75976562 5.60998535,6.75976562 L3,6.76977539 C2.53999999,6.75976562 2.25,6.43977538 2.25,6.01977539 C2.25,5.60977539 2.58000001,5.26977539 3,5.26977539 L5.60998535,5.25976562 C5.61998535,5.25976562 5.62000488,5.25976562 5.63000488,5.25976562 C6.7400049,5.25976562 7.7799927,5.79975832 8.42999268,6.6897583 L9.51000977,8.1897583 C9.75,8.5297583 9.67999634,8.98974609 9.33999634,9.23974609 C9.19999634,9.3297461 9.05001464,9.37976074 8.89001465,9.37976074 C8.66001464,9.37976074 8.42999879,9.26976319 8.27999878,9.06976318 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.589502,17.4099061 L12.3695008,15.8399597 C12.1195008,15.5099597 12.1795057,15.0399109 12.4995057,14.7899109 C12.8295057,14.5399109 13.2994934,14.5999158 13.5494934,14.9199158 L14.7694948,16.4899231 C15.1394948,16.9699231 15.7295129,17.209933 16.3195128,17.249933 L20.9894962,17.2299135 C21.3994962,17.2299135 21.7394962,17.5599135 21.7394962,17.9799135 C21.7394962,18.3899135 21.4094962,18.7299132 20.9894962,18.7299132 L16.3195128,18.7499328 L16.3195128,18.7499328 C15.2595129,18.7499328 14.239502,18.2499061 13.589502,17.4099061 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4694531,6.54995847 L18.4694531,4.54995847 C18.1794531,4.25995848 18.1794531,3.77996093 18.4694531,3.48996094 C18.7594531,3.19996095 19.2394507,3.19996095 19.5294507,3.48996094 L21.5294507,5.48996091 C21.8194506,5.7799609 21.8194506,6.25995848 21.5294507,6.54995847 C21.3794506,6.69995847 21.1894519,6.76999021 20.9994519,6.76999021 C20.8094519,6.76999021 20.6194531,6.69995847 20.4694531,6.54995847 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineShuffle);
export default __webpack_public_path__ + "static/media/vuesax-outline-shuffle.3df231b61cbc0a7f837d44b21654a33c.svg";
export { ForwardRef as ReactComponent };